import { CUSTOMER_JOURNEY_MENU_ERROR } from './../const';

function action() {
  return { type: CUSTOMER_JOURNEY_MENU_ERROR };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyMenuError.js